import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {orders, products, brands, accounts} from 'data/actions';
import {OrderStatus} from 'data/orders/types';

import MenuLink  from 'components/Navigation/MenuLink';


import { Page, PageBlock, RightDrawer } from 'components/Page';

import Subheader from 'material-ui/Subheader';

import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow} from 'material-ui/Table';
import ClickableRowColumn from 'components/Grid/ClickableRowColumn';
import ClickableRow from 'components/Grid/ClickableRow'
import * as os from 'osutil'

class OrdersPage extends Component {
  state = { };

  static contextTypes = {
    router: PropTypes.object
  };
  
  componentWillMount() {
    this.props.actions.fetchOrders();
    this.props.actions.fetchAccounts();
  }

  handleDeleteClick(id) {
    //this.props.actions.deleteCampaign(this.props.user.accountid, id);
  }

  handleEditClick(id) {
    this.context.router.history.push("/admin/order/"+id);
  }

  
  renderOrders = (orders)  => {
    if (!orders || orders.length === 0)
    {
      return null;
    }
    
    return _.map(orders, (campaign, key) => {
      if (!campaign || !campaign.details || !campaign.details.status ) return ;
      var count = campaign.bookings ? Object.keys(campaign.bookings).length : 0;
      var created = campaign.details.created ? os.formatDate(campaign.details.created) : '';
        return (
          <ClickableRow key={key} onMyRowClick={ () => this.handleEditClick(campaign.campaignid)}>
            <ClickableRowColumn>{campaign.account.orgname}</ClickableRowColumn>
            <ClickableRowColumn>{campaign.details.name}</ClickableRowColumn>
            <ClickableRowColumn>{count}</ClickableRowColumn>
            <ClickableRowColumn>{OrderStatus[campaign.details.status]}</ClickableRowColumn>
            <ClickableRowColumn>{created}</ClickableRowColumn>
          </ClickableRow>
       
      );
    });
  }
  render() {
    return [
      <RightDrawer key="right">
        <PageBlock label="Bokningar">
        
        </PageBlock>
      </RightDrawer>,
      <Page key="page"  ready={!this.props.pending}>

        <Table>
          <TableHeader>
            <TableRow>
              <TableHeaderColumn>Företag</TableHeaderColumn>
              <TableHeaderColumn>Namn</TableHeaderColumn>
              <TableHeaderColumn>Annonser</TableHeaderColumn>
              <TableHeaderColumn>Status</TableHeaderColumn>
              <TableHeaderColumn>Skapad</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            {this.renderOrders(this.props.orders)}
          </TableBody>
        </Table>

      
      </Page>
    ]
  }
}

function mapStateToProps(state) {
  var list = [];
  _.forEach(state.orders.list.data, (a, ka) => {
    _.forEach(a, (c, kc) => {
      if (c && c.details && c.details.status)
      {
        c.accountid = ka;
        c.account = state.accounts.list[ka] || {};
        c.campaignid = kc;
        list.push(c);
      }
    })    
  })
  
  return { 
    orders: list,
    pending: state.orders.list.pending
  };
}


const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...products, ...orders, ...brands, ...accounts}, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatch)(OrdersPage)

  



// WEBPACK FOOTER //
// ./src/pages/admin/orders/Orders.jsx